import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import jaTranslations from './locales/ja.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      ja: { translation: jaTranslations },
    },
    
    // This is now the primary default for first-time visitors
    fallbackLng: 'ja', 

    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      // CORRECTED: We ONLY check localStorage. 
      // If nothing is found, it will use fallbackLng ('ja').
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

export default i18n;